module.exports = __webpack_public_path__ + "img/73cfc17.jpg";